'use client'

import { Flex } from 'antd'
import Link from 'next/link'
import { Icon } from 'shared/iconpack'
import { IconNames } from 'shared/iconpack/model/types'

import { PropsWithChildren } from 'react'

import { globalStyles } from 'shared/config/styles/globalStyles'

import styles from './FooterLink.module.scss'

interface FooterLinkProps extends PropsWithChildren {
  label: string
  href: string
  icon?: IconNames
  target?: string
}

export function FooterLink({ label, href, icon, ...props }: FooterLinkProps) {
  return (
    <Link
      href={href}
      prefetch={false}
      rel="noopener noreferrer"
      className={styles.item}
      {...props}
    >
      <Flex gap={8} align="center">
        {icon && (
          <Icon
            name={icon}
            size={18}
            color={globalStyles['--icon-secondary']}
          />
        )}
        <span>{label}</span>
      </Flex>
      <Icon
        name="chevronRight"
        size={16}
        color={globalStyles['--icon-secondary']}
      />
    </Link>
  )
}
